import LocationCard from "./LocationCard/LocationCard";
import "./LocationCards.css";

const LocationCards = ({ locationData, sortOrder, pageSize, loadIndex }) => {
  let sortedGrid = [];
  
  if (locationData?.pins) {
    sortedGrid = locationData?.pins?.slice(0, loadIndex * pageSize)?.sort((a, b) => {
      if (sortOrder === "mostRecent") {
        return new Date(b.createdAt) - new Date(a.createdAt);
      } else if (sortOrder === "mostDesigns") {
        return b.designsCount - a.designsCount;
      } else if (sortOrder === "leastDesigns") {
        return a.designsCount - b.designsCount;
      }
    });
  }

  return (
    <div className="grid-components-wrapper">
      {sortedGrid?.map((gridElement) => (
        <div className="card_wrapper_component"  key={gridElement?.id}>
            <LocationCard
              key={gridElement?.id}
              id={gridElement?.id}
              cityName={locationData?.name}
              country={locationData?.country}
              locationName={gridElement?.name}
              location={[gridElement?.langth, gridElement?.latitued]}
              designsCount={gridElement?.designsCount}
              image={gridElement?.image}
              isAdmin={false}
            /> 
        </div>
        ))}
    </div>
  );
};

export default LocationCards;
